export default "__VITE_ASSET__koYEm6IJ__"